// extracted by mini-css-extract-plugin
export default {"button":"button_button__mXjZJ","highlighted":"button_highlighted__-MMl1","modDisabled":"button_modDisabled__nWUyk"};